export default __webpack_public_path__ + "static/media/AlertIcon.161c302c.svg";